import {PhoneHQButton, PhoneHQCombobox, PhoneHQTooltip} from 'ch3-ui-lib';
import { selectorItem } from "../../utilis/types/Types";
import { useState, useEffect } from "react";

const TYPE_CONFIG = {
    USERS: {
        title: 'Team member is assigned to the following groups',
        label: 'Choose team member',
        headerText: 'The following users are in this group',
        displayHeader: 'USERS'
    },
    PHONE_NUMBERS: {
        title: 'Add phone numbers to group',
        label: 'Choose phone numbers',
        headerText: 'Enable this team member to make and receive calls by assigning phone numbers.',
        displayHeader: 'PHONE NUMBERS'
    },
    GROUPS: {
        title: 'Team member is assigned to the following groups',
        label: 'Choose groups',
        headerText:'Team member is assigned to the following groups',
        displayHeader: 'GROUPS'
    }
};

interface AddContactModalProps {
    data: selectorItem[];
    setData: (items: selectorItem[]) => void;
    type: 'USERS' | 'PHONE_NUMBERS' | 'GROUPS';
    users?: selectorItem[];
    msisdns?: selectorItem[];
    groups?: selectorItem[];
}

const AddUserNumberModal = ({ data, setData, type, users, msisdns, groups }: AddContactModalProps) => {

    const   getAvailableItems = () => {
        switch (type) {
            case 'USERS': return users || [];
            case 'PHONE_NUMBERS': return msisdns || [];
            case 'GROUPS': return groups || [];
            default: return [];
        }
    };
    const [selected, setSelected] = useState<selectorItem[]>(data);
    const [availableItems, setAvailableItems] = useState<selectorItem[]>(getAvailableItems());

    useEffect(() => {
        const allItems = getAvailableItems();
        const filteredItems = allItems.filter(
            item => !selected.some(selectedItem => selectedItem.key === item.key)
        );

        setAvailableItems(filteredItems);
    }, [selected, type, users, msisdns, groups]);

    const handleAddItem = (item: selectorItem) => {
        setAvailableItems(availableItems.filter(i => i.value !== item.value));

        const updatedSelected = [...selected, item];
        setSelected(updatedSelected);
        setData(updatedSelected);
    };

    const handleRemoveItem = (indexToRemove: number) => {
        const removedItem = selected[indexToRemove];
        const updatedSelected = selected.filter((_, index) => index !== indexToRemove);

        setSelected(updatedSelected);
        setData(updatedSelected);
        setAvailableItems([...availableItems, removedItem]);
    };

    const config = TYPE_CONFIG[type] || TYPE_CONFIG.PHONE_NUMBERS;

    return (
        <div className="w-[400px]">
            <div className="text-ink-muted text-sm pb-5">
                {config.headerText}
            </div>

            <div>
                <PhoneHQCombobox
                    label={config.label}
                    placeholder="Search"
                    clearOnSelect
                    onSelect={(item) => handleAddItem(item as selectorItem)}
                    items={availableItems}
                />
            </div>

            {selected.length > 0 && (
                <div className="mt-5 flex flex-col gap-2">
                    <div className="text-caption font-semibold uppercase tracking-wide text-ink-muted">
                        {config.displayHeader}
                    </div>
                    <ul className="m-0 flex list-none flex-col p-0">
                        {selected.map((item, index) => (
                            <li className="flex min-h-12 items-center justify-between gap-3 border-0 border-t border-solid border-line py-1.5 first:border-t-0" key={item.key ?? index}>
                                <div className="flex min-w-0 items-center gap-3">
                                    {item.prefixElement && <div className="flex shrink-0">{item.prefixElement}</div>}
                                    <PhoneHQTooltip content={item.label}><div className="min-w-0 truncate text-callout font-medium text-ink">{item.label}</div></PhoneHQTooltip>
                                </div>
                                <PhoneHQButton variant="text-danger" size="sm" onClick={() => handleRemoveItem(index)} phq-id='groupDetails-removeSelectedBtn'>Remove</PhoneHQButton>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default AddUserNumberModal;